var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('form',_vm._g({staticClass:"nx-form",class:{ 'nx-active': _vm.active },attrs:{"data-vv-scope":_vm.scope}},_vm.$listeners),[_vm._t("default",null,null,{ draft: _vm.draft, form: _vm.form, formErrors: _vm.formErrors })],2)}
var staticRenderFns = []

export { render, staticRenderFns }